import ApiService from "./ApiService";

const ENDPOINTS = {
  NEWSLETTER: "/kontakt/message/mailchimp",
  CONTACT: "/kontakt/message"
};

class EmailService extends ApiService {
  subscribeToNewsletter = (email) => {
    return this.apiClient.post(ENDPOINTS.NEWSLETTER, email);
  };

  sendContactMessage = (message) => {
    return this.apiClient.post(ENDPOINTS.CONTACT, message);
  };
}

const emailService = new EmailService();
export default emailService;
